import { io } from 'socket.io-client';
import { SessionEvent } from './types';

export type LiveStatus = 'connecting' | 'live' | 'offline';

export type LiveHandlers = {
  onUpdate: (event: SessionEvent) => void;
  onStatus: (status: LiveStatus) => void;
};

/** Joins a split's room and passes on every change. Returns a way to leave. */
export type LiveConnect = (shareToken: string, handlers: LiveHandlers) => () => void;

/**
 * socket.io to the backend: `split:join_public` with the share token (again
 * after every reconnect), then `split:session_updated` with the public view
 * after each change. REST stays the source of truth; this only says when.
 */
export const connectLive: LiveConnect = (shareToken, { onUpdate, onStatus }) => {
  const base = process.env.REACT_APP_API_BASE_URL || window.location.origin;
  const socket = io(base, { path: '/socket.io', transports: ['websocket', 'polling'] });
  onStatus('connecting');
  socket.on('connect', () => {
    socket.emit('split:join_public', { shareToken }, (ack: { success?: boolean } | undefined) => {
      onStatus(ack?.success ? 'live' : 'offline');
    });
  });
  socket.on('disconnect', () => onStatus('offline'));
  socket.on('connect_error', () => onStatus('offline'));
  socket.on('split:session_updated', (event: SessionEvent) => {
    if (event?.session) onUpdate(event);
  });
  return () => {
    socket.removeAllListeners();
    socket.disconnect();
  };
};
